export default[
    {//首页
        path: '/',
        redirect:"/chat",
        component: function (resolve) {
            require(['./Layout.vue'], resolve);
            // require(['./Index.vue'], resolve);
        },
        children:[
            {
                path: '/chat',
                component: function (resolve) {
                    require(['./Chat.vue'], resolve);
                }
            },
            {
                path: '/draw',
                component: function (resolve) {
                    require(['./Draw.vue'], resolve);
                }
            },
            {
                path: '/create',
                component: function (resolve) {
                    require(['./Create.vue'], resolve);
                }
            },
        ]
    },
    {//登录页
        path: '/login',
        component: function (resolve) {
            require(['./Login.vue'], resolve);
        }
    },
    {
        path: '/share',
        component: function (resolve) {
            require(['./share.vue'], resolve);
        }
    },
    // {
    //     path: '/home',
    //     component: function (resolve) {
    //         require(['./Home.vue'], resolve);
    //     }
    // }
]